import { render } from "./WidgetLoader.vue?vue&type=template&id=bb0a1e9a&scoped=true"
const script = {}

import "./WidgetLoader.vue?vue&type=style&index=0&id=bb0a1e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0a1e9a"]])

export default __exports__